export default __webpack_public_path__ + "static/media/Paper.93b96788.png";